<template>
    <div class="card personal-card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">{{ personal.nombre }} {{ personal.apellido }}</h5>
        <span :class="['badge', estadoClass]">{{ personal.estado }}</span>
      </div>
      <div class="card-body">
        <p class="mb-2"><strong>Rol:</strong> {{ personal.rol }}</p>
        <p class="mb-2"><strong>Email:</strong> <a :href="'mailto:' + personal.email">{{ personal.email }}</a></p>
        <p class="mb-2"><strong>Teléfono:</strong> <a :href="'tel:' + personal.telefono">{{ personal.telefono }}</a></p>
        <p class="mb-2"><strong>Legajo:</strong> {{ personal.legajo }}</p>
        <p class="mb-2" v-if="personal.fecha_contratacion">
          <strong>Contratación:</strong> {{ formatDate(personal.fecha_contratacion) }}
        </p>
        <p class="mb-0" v-if="personal.comentarios">
          <strong>Comentarios:</strong> {{ personal.comentarios }}
        </p>
      </div>
     
    </div>
  </template>
  
  <script>
  export default {
    props: {
      personal: {
        type: Object,
        required: true,
      },
    },
    computed: {
      estadoClass() {
        const estadoClases = {
          activo: 'badge-success',
          inactivo: 'badge-secondary',
          suspendido: 'badge-warning',
          licencia: 'badge-info',
        };
        return estadoClases[this.personal.estado] || 'badge-dark';
      },
    },
    methods: {
      formatDate(date) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(date).toLocaleDateString('es-ES', options);
      },
    },
  };
  </script>
  
  <style scoped>
  .personal-card {
    max-width: 400px;
    margin: 0 auto;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  .card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #ddd;
  }
  .badge {
    font-size: 0.9rem;
    padding: 0.4em 0.6em;
    text-transform: capitalize;
  }
  .card-footer {
    background-color: #f8f9fa;
    border-top: 1px solid #ddd;
  }
  </style>
  